import script from "./SellerHero.vue?vue&type=script&setup=true&lang=ts"
export * from "./SellerHero.vue?vue&type=script&setup=true&lang=ts"

import "./SellerHero.vue?vue&type=style&index=0&id=52987374&scoped=true&lang=scss"

import exportComponent from "/Users/alesandraefimova/Work/x-global-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52987374"]])

export default __exports__